export default "__VITE_ASSET__55db7375__"